import axios, { AxiosRequestConfig, Canceler } from 'axios'
import { post, get } from './helpers'
import { TranscriptData } from '../data/transcript'
import { Job } from '../data/job'
import { ApiResponse, PaginationMeta } from '../data/api'
import { UserMeta } from '../data/user'
import { JobInvoiceItem } from '../data/job_invoice_item'

export interface CreditCard {
  id: string
  brand: "American Express" | "Diners Club" | "Discover" | "JCB" | "MasterCard" | "UnionPay" | "Visa" | "Unknown"
  country: string
  default_source: boolean
  exp_month: number
  exp_year: number
  last4: string
  name: string
}

type UploadProgressCallback = (percentCompleted: number) => void

export default {
  jobs: {
    list:          ()           => get<ApiResponse<Job[], PaginationMeta>>('/api/v1/jobs'),
    get:           (id: string) => get<ApiResponse<Job>>(`/api/v1/jobs/${id}`),
    create:        (data: any)  => post<ApiResponse<Job>>('/api/v1/jobs', { job: data }),
    jobTranscript: (id: string) => get<ApiResponse<TranscriptData>>(`/api/v1/jobs/${id}/transcript`),
    jobMedia:      (id: string) => get<ApiResponse<{media: string}>>(`/api/v1/jobs/${id}/media`),
  },

  uploads: {
    presign: () => post('/api/v1/uploads/presign')
  },

  user: {
    meta: () => get<ApiResponse<UserMeta>>(`/api/v1/user/meta`)
  },

  billing: {
    listCards:      ()                  => get<ApiResponse<CreditCard[]>>(`/api/v1/billing/cards`),
    addCard:        (cardToken: string) => post<ApiResponse<CreditCard[]>>(`/api/v1/billing/cards`, { cardToken }),
    setDefaultCard: (cardId: string)    => post<ApiResponse<CreditCard[]>>(`/api/v1/billing/default_card`, { cardId }),
    invoice:        ()                  => get<ApiResponse<JobInvoiceItem[]>>(`/api/v1/billing/invoice`),
  },

  uploadToS3: async (data: any, uploadFile: any, uploadProgressCallback: UploadProgressCallback, setCanceler: (canceler: Canceler) => void) => {
    const form = new FormData()
    for (let key in data.data.fields) {
      let value = data.data.fields[key]
      form.append(key, value)
    }
    const fileName = uploadFile.name
    const fileNameParts = fileName.split('.')

    let s3FileName = 'upload'
    if (fileNameParts.length >= 2) {
      s3FileName += '.' + fileNameParts[fileNameParts.length-1]
    }
    const s3Key = data.prefix + s3FileName
    form.append('key', s3Key)
    form.append('file', uploadFile)

    const cancelSource = axios.CancelToken.source()
    setCanceler(cancelSource.cancel)

    const config: AxiosRequestConfig = {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        uploadProgressCallback(percentCompleted)
      },
      cancelToken: cancelSource.token,
    }

    const uploadUrl = `https://${data.data.fields.bucket}.s3-accelerate.dualstack.amazonaws.com`

    await axios
      .post(uploadUrl, form, config)

    return ({ fileName, key: s3Key })
  }
}
